import Vue from 'vue'
import { MLInstaller, MLCreate, MLanguage } from 'vue-multilanguage'
Vue.use(MLInstaller)
export default new MLCreate({
  initial: 'en',
  save: process.env.NODE_ENV === 'production',
  languages: [
    new MLanguage('en').create({
      '': '',
      user: 'User',
      pass: 'Password',
      welcome: 'Welcome',
      change_pass: 'Change Password',
      metrics: 'Metrics',
      metric: 'Metric',
      from: 'From',
      to: 'To',
      ok: 'Ok',
      reset: 'Reset',
      messages: 'Messages',
      unsent_messages: 'Unsent messages',
      total_subscriptions: 'Total Subscriptions',
      empty_AWB: 'Empty AWB',
      AWB_status: 'AWB Status',
      type: 'Type',
      provider: 'Proveedor',
      total: 'Total',
      with_info: 'With Information',
      without_info: 'Without information'
    }),
    new MLanguage('es').create({
      '': '',
      user: 'Usuario',
      pass: 'Contraseña',
      welcome: 'Bienvenid@',
      change_pass: 'Cambiar Contraseña',
      metrics: 'Métricas',
      metric: 'Métrica',
      from: 'Desde',
      to: 'Hasta',
      ok: 'Ok',
      reset: 'Reset',
      messages: 'Mensajes',
      unsent_messages: 'Mensajes sin enviar',
      total_subscriptions: 'Subscripciones totales',
      empty_AWB: 'AWB Vacios',
      AWB_status: 'AWB Status',
      type: 'Tipo',
      provider: 'Proveedor',
      total: 'Total',
      with_info: 'Con Información',
      without_info: 'Sin información'
    })
  ]
})



// WEBPACK FOOTER //
// ./src/language.js